import { trackEvent } from "@/lib/analytics";

const WA_PATH = "M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.64.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.61-.92-2.21-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.07 2.88 1.21 3.07.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.08 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.12-.27-.2-.57-.35M12.05 21.5h-.01a9.5 9.5 0 0 1-4.84-1.33l-.35-.21-3.6.94.96-3.5-.23-.36a9.46 9.46 0 0 1-1.45-5.04C2.53 6.76 6.8 2.5 12.06 2.5c2.55 0 4.94.99 6.74 2.79a9.43 9.43 0 0 1 2.78 6.73c0 5.25-4.27 9.48-9.53 9.48m8.1-17.59A11.4 11.4 0 0 0 12.05.5C5.7.5.53 5.65.53 12c0 2.03.53 4.01 1.54 5.76L.44 23.5l5.9-1.54a11.47 11.47 0 0 0 5.7 1.45h.01c6.35 0 11.52-5.15 11.52-11.5 0-3.07-1.2-5.96-3.38-8.13";

const shareText = (entry) =>
  [
    `“${entry.english_question}”`,
    entry.hindi_question || null,
    "",
    `BollyGPT's answer: ${window.location.origin}${entry.path}`,
  ].filter((l) => l !== undefined && l !== null).join("\n");

export const ShareButton = ({ entry }) => (
  <a
    href={`https://wa.me/?text=${encodeURIComponent(shareText(entry))}`}
    target="_blank"
    rel="noopener noreferrer"
    onClick={() => trackEvent("share_whatsapp", entry)}
    data-testid="share-whatsapp-button"
    className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-2.5 text-sm font-bold text-slate-900 transition-transform hover:scale-105 active:scale-95"
  >
    <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor" aria-hidden><path d={WA_PATH} /></svg>
    Share on WhatsApp
  </a>
);
